import React, { useEffect, useState } from "react";
import { FiCheckCircle, FiX } from "react-icons/fi";

const getAdminName = () => {
  try {
    const stored = localStorage.getItem("admin");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed?.name || parsed?.username || parsed?.email || "Admin";
    }
  } catch {
    // fall through to localStorage "name" / default below
  }
  return localStorage.getItem("name") || "Admin";
};

/**
 * Presentation-only. Shows a one-time "Welcome back" toast on the right
 * side of the screen right after Login.jsx sets the `justLoggedIn` flag.
 * No API calls, no data fetching — reads only what is already in storage.
 */
const WelcomePanel = () => {
  const [visible, setVisible] = useState(false);
  const [adminName, setAdminName] = useState("Admin");

  useEffect(() => {
    if (sessionStorage.getItem("justLoggedIn") !== "1") return undefined;

    sessionStorage.removeItem("justLoggedIn");
    setAdminName(getAdminName());

    const showTimer = requestAnimationFrame(() => setVisible(true));
    const hideTimer = setTimeout(() => setVisible(false), 6000);

    return () => {
      cancelAnimationFrame(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <div
      className={`welcome-panel ${visible ? "is-visible" : ""}`}
      role="status"
      aria-live="polite"
      style={{ pointerEvents: visible ? "auto" : "none" }}
    >
      <span className="welcome-panel__icon">
        <FiCheckCircle />
      </span>
      <div>
        <p className="welcome-panel__title">Welcome back, {adminName}</p>
        <p className="welcome-panel__body">
          You're signed in. Here's today's overview.
        </p>
      </div>
      <button
        type="button"
        className="welcome-panel__close"
        aria-label="Dismiss"
        onClick={() => setVisible(false)}
      >
        <FiX />
      </button>
    </div>
  );
};

export default WelcomePanel;
